import { render, staticRenderFns } from "./RepRank.vue?vue&type=template&id=45b4b79a&scoped=true&"
import script from "./RepRank.vue?vue&type=script&lang=js&"
export * from "./RepRank.vue?vue&type=script&lang=js&"
import style0 from "./RepRank.vue?vue&type=style&index=0&id=45b4b79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b4b79a",
  null
  
)

export default component.exports